import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ProviderPhotoKey } from "@src/interfaces/provider-photo.interface";
import type { ApiCallConfig } from "@src/utils/api-client";

export interface ProviderPhotosRequest {
  providers: ProviderPhotoKey[];
  user_uuid?: string;
}

/**
 * Builds the callApi config for the provider-photos endpoint.
 */
export function buildProviderPhotosConfig(request: ProviderPhotosRequest): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.PROVIDER_PHOTOS,
    body: {
      user_uuid: request.user_uuid,
      providers: request.providers,
    } as Record<string, unknown>,
  };
}
